<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('chat-bots') }} -> {{ $t('settings') }}
    </h1>
    <div class="main__body">
      <div class="form-row">
        <div class="form-group">
          <label>Telegram</label>
          <input class="large" type="text" placeholder="Telegram" v-model="bots.telegram">
        </div>
        <div class="form-group">
          <label>Viber</label>
          <input class="large" type="text" placeholder="Viber" v-model="bots.viber">
        </div>
      </div>
      <div class="form-row mt-1">
        <button class="btn btn-primary" type="submit" @click="createOrDelete">{{ $t('save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'createBot',
  data: function(){
    return{
      bots: {
        telegram: '',
        viber: '',
      },
      errors: [],
    }
  },
  created() {
    this.getBots();
  },
  methods: {
    createOrDelete: function(){
      axios.post('createOrDeleteBot', this.bots).then(response => {
        var status = response.data.status;
        if(status){
          this.$toast.success("Настройки сохранены");
        }
      });
    },
    getBots: function(){
      axios.post('getBots').then(response => {
        var status = response.data.status;
        var $this = this;
        if(status){
          response.data.bots.map(function(value) {
            if(value.type == 1){
              $this.bots.telegram = value.token;
            }else if(value.type == 2){
              $this.bots.viber = value.token;
            }
          });
        }
      });
    },
  },
}
</script>